import { render, staticRenderFns } from "./AlertWithoutDesc.vue?vue&type=template&id=53071cf8&"
import script from "./AlertWithoutDesc.vue?vue&type=script&lang=js&"
export * from "./AlertWithoutDesc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports